export default __webpack_public_path__ + "8613f9c8579f58add83ad0304922a248.svg";